import React from "react";
// recoil
import { useRecoilState } from "recoil";
// @Mui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// atoms
import { deleteConfirmationPopUpAtom } from "src/recoil";
//
import Iconify from "./Iconify";

// ----------------------------------------------------------------

function DeleteConfirmationPopUp() {
  const [popUp, setPopUp] = useRecoilState(deleteConfirmationPopUpAtom);

  const closeHandler = () => {
    setPopUp({ isTriggered: false, title: "", content: "" });
  };

  return (
    <Dialog open={popUp.isTriggered} onClick={closeHandler}>
      <DialogTitle>
        <Stack direction="row" alignItems="center" gap={1}>
          <Iconify
            sx={{ width: 30, height: 30, color: "error.main" }}
            icon="solar:shield-warning-broken"
          />
          <Typography variant="h6">{popUp.title}</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mt: 1 }}>{popUp.content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeHandler} variant="outlined" color="error">
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          endIcon={<Iconify icon="solar:map-arrow-right-broken" />}
          loading={popUp.isLoading}
          onClick={popUp.action}
        >
          Proceed
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteConfirmationPopUp;
